/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { ActionButton, LoneIconButton, PopoverList } from '@blend/enterprise-components';

import { ActionsCell } from '../styles';

interface TeamsAdminActionsProps {
  openEditTeamInfoModal: () => void;
  openDeleteTeamModal: () => void;
  openInviteTeamMembersModal: () => void;
  teamId: string;
}

const TeamsAdminActions: React.FC<TeamsAdminActionsProps> = ({
  openEditTeamInfoModal,
  openDeleteTeamModal,
  openInviteTeamMembersModal,
  teamId,
}) => (
  <ActionsCell>
    <ActionButton label="Invite" onClick={openInviteTeamMembersModal} theme="tertiary" />
    <div>
      {/* wrapped in div because PopoverList inserts an empty div in its parent container which adds an undesirable flex gap */}
      <PopoverList
        anchorPosition="bottom-end"
        buttonConfigs={[
          {
            icon: 'info',
            id: `it-edit-team-info-${teamId}`,
            key: 'edit-team',
            label: 'Edit team info',
            onClick: openEditTeamInfoModal,
          },
          {
            icon: 'close',
            id: `it-delete-team-${teamId}`,
            key: 'delete-team',
            label: 'Delete team',
            onClick: openDeleteTeamModal,
          },
        ]}
      >
        <LoneIconButton
          aria-label="More actions"
          btnSize={36}
          icon="more_horiz"
          iconSize={18}
          id={`it-more-team-actions-${teamId}`}
          theme="tertiary"
        />
      </PopoverList>
    </div>
  </ActionsCell>
);

export default TeamsAdminActions;
